import { memo, ReactChild, ReactFragment, ReactPortal } from "react";

const TabPanel = memo((props: { children: ReactChild | ReactFragment | ReactPortal | boolean | null | undefined }) => {
	return <>{props.children}</>;
});

export default TabPanel;
